import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import * as AllIcons from '@ant-design/icons-angular/icons';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { HttpLoaderFactory } from '@app-shared/services/translate-loader.service';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { FORMLY_CONFIG, provideFormlyCore } from '@ngx-formly/core';
import {
  FormlyNgZorroAntdModule,
  withFormlyNgZorroAntd,
} from '@ngx-formly/ng-zorro-antd';
import { formlyConfig } from '@app-shared/formly.config';
import { BuildingIcon, LineLogoIcon, UserTieIcon } from '@app-shared/icons';
import { NzConfig, provideNzConfig } from 'ng-zorro-antd/core/config';

registerLocaleData(en);

const icons = [
  ...Object.values(AllIcons),
  LineLogoIcon,
  UserTieIcon,
  BuildingIcon,
];

const ngZorroConfig: NzConfig = {
  message: {
    nzTop: 0,
    nzDuration: 2500,
  },
  notification: {
    nzDuration: 1000,
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNzI18n(en_US),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    importProvidersFrom(
      FormsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        fallbackLang: 'ja',
      }),
      FormlyNgZorroAntdModule
    ),
    {
      provide: FORMLY_CONFIG,
      multi: true,
      useFactory: formlyConfig,
      deps: [TranslateService],
    },
    provideFormlyCore([...withFormlyNgZorroAntd()]),
    provideAnimationsAsync(),
    provideNzIcons(icons),
    provideNzConfig(ngZorroConfig),
  ],
};
